import SeoService from './SeoService';

export default SeoService;
